export interface PresignedResponse {
  uploadUrl: string;
  downloadUrl: string;
  url: string;
}

export enum FileShareScope {
  ALL = 'all',
  ORG = 'org',
  EMPLOYEE = 'employee',
}

export enum FileHideScope {
  NONE = 'none',
  ORG = 'org',
  EMPLOYEE = 'employee',
}
